import { AxiosError, AxiosRequestConfig } from 'axios';
import { isNetworkOrIdempotentRequestError } from 'axios-retry';

export const RETRY_COUNT = 3;
export const RETRY_DELAY_FACTOR_MS = 250;

const SAFE_METHODS = ['get', 'head', 'options'];

const isSafeMethod = (error: AxiosError): boolean =>
  SAFE_METHODS.includes(error.config?.method?.toLowerCase() ?? '');

// A timeout can't tell "never arrived" from "processed but response lost", so retry it only
// on side-effect-free reads.
const isRetryableTimeout = (error: AxiosError): boolean =>
  error.code === 'ECONNABORTED' && isSafeMethod(error);

export const shouldRetryRequest = (error: AxiosError): boolean =>
  // No config means axios-retry won't retry it, so treat it as non-retryable here too —
  // otherwise the response interceptor would skip reporting a failure that never retries.
  Boolean(error.config) &&
  (isNetworkOrIdempotentRequestError(error) || isRetryableTimeout(error));

export const NO_RETRY: AxiosRequestConfig = { 'axios-retry': { retries: 0 } };
